import {
  PaymentType,
  StripeOrderDTO,
  StripeOrderStatus,
} from "../../../Stripe/StripeOrderDTO.ts";

const SETTLEABLE_STATUSES = [
  StripeOrderStatus.InstallmentPaid,
  StripeOrderStatus.InstallmentDelinquent,
];

export const NOT_SETTLEABLE_REASON =
  "Il saldo rate è possibile solo per gli ordini a rate con rate pagate o insolute";

export function canSettleInstallments(order: StripeOrderDTO): boolean {
  return (
    order.paymentType === PaymentType.Installments &&
    SETTLEABLE_STATUSES.includes(order.status)
  );
}
